import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';
import {TextInputSelection} from '../TextInputSelection/TextInputSelection';
import {IWithDisabled} from 'models/common';

type IDisplayNameTextInputProps = IWithDisabled;

export const DisplayNameTextInput: FC<IDisplayNameTextInputProps> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.displayName}
    label="Asset Name"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.assetName}
  />
);
